import UserProxy from '@/proxies/UserProxy';
import * as types from './mutation-types';
import store from '@/store/index'

export const me = ({ commit }) => {
  new UserProxy()
    .me()
    .then((response) => {
      commit(types.ME, response);
    })
    .catch(() => {
    });
};

export const getMyMenus = ({ commit }) => {
  new UserProxy()
    .getMyMenus()
    .then((response) => {
      commit(types.MY_MENUS, response);
    })
    .then(() => {
      // q&a 대기 갯수 
      store.dispatch('board/qnaCnt', 1)

    })
    .catch(() => {

    })
};

export default {
  me,
  getMyMenus,
};
